type Args = {
  step: number;
  precision: number;

  wrapper?: {
    fromTranslate: { x: number; y: number };
    toTranslate: { x: number; y: number };
  };

  content?: {
    fromTranslate: { x: number; y: number };
    toTranslate: { x: number; y: number };
  };

  easing: (progress: number) => number;
};

export function createTranslateKeyFrame({
  step,
  precision,
  wrapper,
  content,
  easing,
}: Args): [string, string] {
  const easedStep = easing(step / precision);
  let wrapperTranslate = "";
  let contentTranslate = "";

  if (wrapper) {
    const wrapperTranslateX =
      wrapper.fromTranslate.x +
      (wrapper.toTranslate.x - wrapper.fromTranslate.x) * easedStep;
    const wrapperTranslateY =
      wrapper.fromTranslate.y +
      (wrapper.toTranslate.y - wrapper.fromTranslate.y) * easedStep;

    wrapperTranslate = `translate3d(${wrapperTranslateX}px, ${wrapperTranslateY}px, 0px)`;
  }

  if (content) {
    const contentTranslateX =
      content.fromTranslate.x +
      (content.toTranslate.x - content.fromTranslate.x) * easedStep;
    const contentTranslateY =
      content.fromTranslate.y +
      (content.toTranslate.y - content.fromTranslate.y) * easedStep;

    contentTranslate = `translate3d(${contentTranslateX}px, ${contentTranslateY}px, 0px)`;
  }

  return [wrapperTranslate, contentTranslate];
}
